import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-base-date-time-input',
    standalone: false,
    templateUrl: './base-date-time-input.component.html',
    styleUrl: './base-date-time-input.component.scss',
})
export class BaseDateTimeInputComponent extends InputComponent {
    get date(): Date | null {
        return this.fc.value ? new Date(this.fc.value) : null;
    }

    set date(val: Date | null) {
        if (!val) {
            this.fc.setValue(null);
            return;
        }
        const old = this.fc.value ? new Date(this.fc.value) : null;
        if (old) {
            val.setHours(old.getHours(), old.getMinutes(), 0, 0);
        }
        this.fc.setValue(new Date(val));
    }

    get time(): string {
        const d = this.date;
        if (!d) return '';
        // Use local time for input type="time"
        const pad = (n: number) => n.toString().padStart(2, '0');
        return pad(d.getHours()) + ':' + pad(d.getMinutes());
    }

    set time(val: string) {
        const d = this.date ? new Date(this.date) : new Date();
        if (!val) {
            d.setHours(0, 0, 0, 0);
        } else {
            const [h, m] = val.split(':').map(Number);
            d.setHours(h, m, 0, 0);
        }
        this.fc.setValue(d);
    }
}
